module.exports = __webpack_public_path__ + "components/flag/static/square/fm-eec2cffae18460c45617ee2002bd5fe9.svg";